import { dateToolTip } from './toolTipFormatter'
import HT from 'highcharts/highcharts-more'
import Highcharts from 'highcharts'
import getNumberFromString from '../../utils/getNumberFromString'
import getStringFromNumberString from '../../utils/getStringFromNumberString'
HT(Highcharts)

const areaChartOptionsAqi = (data,
  chartName = '',
  ) => {
  return {
    chart: {
      type: 'line',
    },
    title: {
      text: '',
    },
    
    xAxis: {
      // tickLength: 10,
      // tickInterval:1,
      type: 'datetime',
      labels: {
        align:'right',
        x:-20,
        y:20,
        formatter: function () {
          // Subtract 2 day from the actual date in this.value to show the x-axis compatible with the data on the trend
          return Highcharts.dateFormat('%b %e', this.value - (86400000*2))
        },
      },
    },
    yAxis:{
      title: {
        text: chartName==='POLLEN'?'g/m&sup3;':'AQI',
        style: {
          color: Highcharts.getOptions().colors[1],
          fontSize: '14px',
        },
      },
     
      labels: {
        style: {
          fontSize: '16px',
          fontWeight: '400',
          color: '#4B4D4F',
        },
      },
    },
    // yAxis: chartName==='POLLUTANT'?{
    //   min: 0,
    //   max:300,
    //   title: {
    //     text: chartName==='POLLEN'?'g/m&sup3;':'AQI',
    //     style: {
    //       color: Highcharts.getOptions().colors[1],
    //       fontSize: '14px',
    //     },
    //   },
     
    //   labels: {
    //     style: {
    //       fontSize: '16px',
    //       fontWeight: '400',
    //       color: '#4B4D4F',
    //     },
    //   },
    // }:{
    //   title: {
    //     text: chartName==='POLLEN'?'g/m&sup3;':'AQI',
    //     style: {
    //       color: Highcharts.getOptions().colors[1],
    //       fontSize: '14px',
    //     },
    //   },
     
    //   labels: {
    //     style: {
    //       fontSize: '16px',
    //       fontWeight: '400',
    //       color: '#4B4D4F',
    //     },
    //   },
    // },

    tooltip: {
      crosshairs: true,
      shared: true,
      useHTML: true,
      padding: 0,
      formatter: dateToolTip,
    },
    credits: {
      enabled: false,
    },
    legend: {
      layout: 'horizontal',
      align: 'center',
      useHTML: true,
      verticalAlign: 'bottom',
      labelFormatter: function () {
        return `${getStringFromNumberString(this.name)}<sub>${getNumberFromString(this.name)}</sub>`
    }
    },
    plotOptions: {
      
      line: {
       
        marker: {
          enabled: true,
        },
      },
    },
      series: data,
    

   
  }
  }
export default areaChartOptionsAqi
